angular.module('impactx.toolbar').controller('ListToolbarCtrl', [
    '$scope',
    'sidebarShow',
    'TranslationService',
    'BackService',
    '$window',
    '$securityManager',
    '$timeout',
    'selectedListItems',
    ListToolbarCtrl]);

function ListToolbarCtrl($scope, sidebarShow, TranslationService, BackService, $window, $securityManager, $timeout, selectedListItems) {
    var ctrl = this;

    ctrl.getLabel = function(translationKey) {
        return TranslationService.get(translationKey);
    };

    ctrl.back = function() {
        BackService.back();
    };

    ctrl.sidebarShow = sidebarShow;
    $scope.abortLabel = ctrl.getLabel('back');

    ctrl.isActionAllowed = function(name) {
        var isActionAllowed = false;
        var action = ctrl.getAction(name);
        if(action) {
            isActionAllowed = action.allowed;
        }
        return isActionAllowed
    };

    ctrl.getActionLabel = function(name) {
        var label = "";
        var action = ctrl.getAction(name);
        if(action) {
            label = action.label;
        }
        return label
    };

    ctrl.getAction = function(name) {
        var action = null;
        var data = $scope.data;
        if(data) {
            var actions = data.actions;
            if(actions) {
                action = actions[name];
            }
        }
        return action;
    };

    $scope.toolbarButtons = [];
    $scope.dropDownButtons = [];
    var i = 0;
    if($scope.metaData.buttonDefinition) {
        var noChangedCondition = false;
        while(i < $scope.metaData.buttonDefinition.length) {
            (function(button) {
                $scope.$watch(function() {
                    return button.condition ? button.condition($scope.data ? $scope.data.additionalFields : null) : true;
                }, function(newValue, oldValue) {
                    if(newValue != oldValue) {
                        noChangedCondition = false;
                    }
                });
            })($scope.metaData.buttonDefinition[i]);
            i++;
        }

        $scope.recalcButtons = function() {
            $scope.toolbarButtons = [];
            $scope.dropDownButtons = [];
            //- 60 for the dropdown button, -165 for delete selection button, -201 for pagination buttons, -110 are the toggle buttons for sidebar and the refresh button
            var totalWidth = angular.element("#ix-md-dialog-toolbar").width() - 60 - 165 - 201 - 110 - 110;
            var currUsedWidth = 0;
            var i = 0;
            while(i < $scope.metaData.buttonDefinition.length) {
                var currentButton = $scope.metaData.buttonDefinition[i];

                if((!currentButton.condition || currentButton.condition($scope.data ? $scope.data.additionalFields : null)) &&
                    (!currentButton.process || $securityManager.isProcessAllowed(currentButton.process))) {
                    //104 is the min width of a button. 12 is the total padding, 16 is the total margin
                    currUsedWidth += Math.max(104, ctrl.getWidthOfText($scope.trns[currentButton.label], 'Roboto, "Helvetica Neue", sans-serif;', '14px', '600', '.01em') + 12 + 16);
                    if(currUsedWidth >= totalWidth) {
                        break;
                    }
                    $scope.toolbarButtons.push(currentButton);
                }
                i++;
            }
            while(i < $scope.metaData.buttonDefinition.length) {
                var currentButton = $scope.metaData.buttonDefinition[i];
                if((!currentButton.condition || currentButton.condition($scope.data ? $scope.data.additionalFields : null)) &&
                    (!currentButton.process || $securityManager.isProcessAllowed(currentButton.process))) {
                    $scope.dropDownButtons.push($scope.metaData.buttonDefinition[i]);
                }
                i++;
            }
        };

        this.getWidthOfText = function(txt, fontname, fontsize, fontweight, letterspacing) {
            var e = document.createElement('span');
            e.style.fontSize = fontsize;
            e.style.fontFamily = fontname;
            e.style.fontWeight = fontweight;
            e.style.letterSpacing = letterspacing;
            if(txt) {
                e.innerHTML = txt.toUpperCase();
            }
            document.body.appendChild(e);
            var w = e.offsetWidth;
            document.body.removeChild(e);
            return w;
        };


        $scope.$watch(function() {
            return angular.element("#ix-md-dialog-toolbar").width();
        }, function(newValue, oldValue) {
            if(newValue != oldValue && $scope.data) {
                $scope.recalcButtons();
            }
        });

        $window.onresize = function() {
            if($scope.data) {
                $scope.recalcButtons();
                $timeout(function() {
                    $scope.$evalAsync();
                });
            }
        };

        $scope.$watch(function() {
            if(noChangedCondition) return;
            noChangedCondition = true;
            $scope.$$postDigest(function() {
                if($scope.data) {
                    $scope.recalcButtons();
                }
            });
        });

        $scope.$on('$destroy', function() {
            $window.onresize = null;
        });
    }
}